import { UserController } from '@/controllers/User';
import { CompanyVm, ReduxSagaAction } from '@/types';

import { UserActionTypes } from './action-types';

export const setLegacyUserInfo = payload => ({
  type: UserActionTypes.FETCH_USER_INFO.SUCCESS,
  payload,
});

export const clearLegacyUserInfo = () => ({
  type: UserActionTypes.FETCH_USER_INFO.FAIL,
});

export const acceptLeadsPassingProgram = (companyId: CompanyVm['id']): ReduxSagaAction => ({
  type: UserActionTypes.ACCEPT_LEADS_PASSING_PROGRAM.START,
  subtypes: UserActionTypes.ACCEPT_LEADS_PASSING_PROGRAM,
  promise: () => UserController.acceptLeadsPassingProgram(companyId),
});
